import { CardShardSlot } from "@/types/shards"

export function getInstalledShardSlots(
  shardSlots: CardShardSlot[] | undefined | null
): Array<CardShardSlot & { shard: NonNullable<CardShardSlot["shard"]> }> {
  if (!Array.isArray(shardSlots)) return []
  return shardSlots
    .filter(
      (
        slot
      ): slot is CardShardSlot & { shard: NonNullable<CardShardSlot["shard"]> } =>
        slot.shard != null
    )
    .sort((a, b) => a.slotIndex - b.slotIndex)
}
